import * as userRequest from "@/utils/userRequest";

export default async function getLimitInvestService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("campaign/investmemt-rules", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getLimitInvestService ~ res:", res);
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getLimitInvestService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
